import React, { useState } from "react";
import {
  DateField,
  Datagrid,
  FilterButton,
  List,
  RefreshButton,
  SimpleList,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";

import {
  useMediaQuery,
  Divider,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";

import { ForceTitle } from "../../../components/common/ForceTitle";
import { NewCustomerStatusOptions } from "../../../utils/constants";

const tabs = NewCustomerStatusOptions;

const getListFilters = () => [
  <TextInput
    source="businessName.beginsWith"
    label="Yard name"
    variant="outlined"
    fullWidth
    resettable
    alwaysOn
  />,
  <TextInput
    source="lastName.beginsWith"
    label="Last name"
    variant="outlined"
    fullWidth
    resettable
    alwaysOn
  />,
];

const ListActions = (props) => {
  return (
    <TopToolbar>
      <FilterButton />
      <RefreshButton />
    </TopToolbar>
  );
};

const SetupList = (props) => {
  const [tabValue, setTabValue] = useState(
    sessionStorage.getItem("SetupDataTab")
      ? sessionStorage.getItem("SetupDataTab")
      : 1
  );

  const initFilterValues = {
    setupDataByStatusBySubmitDate: {
      status: tabs[tabValue].id,
    },
  };

  return (
    <List
      {...props}
      title={<ForceTitle title="Registrations" />}
      filter={initFilterValues}
      sort={{ field: "submitDate", order: "DESC" }}
      filters={getListFilters()}
      actions={<ListActions />}
      bulkActionButtons={false}
    >
      <SetupDataGrid {...props} tabValue={tabValue} setTabValue={setTabValue} />
    </List>
  );
};

const SetupDataGrid = ({ tabValue, setTabValue, ...props }) => {
  const handleChange = (event, value) => {
    sessionStorage.setItem("SetupDataTab", value);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map((itm, idx) => (
          <Tab key={itm.id} label={itm.name} id={`setup-${idx}`} />
        ))}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <SetupGrid {...props} key={itm.id} tabValue={itm.id} />
          )
      )}
    </>
  );
};

const SetupGrid = ({ tabValue, ...props }) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  debugger;
  return isXSmall ? (
    <SimpleList
      primaryText={(record) => record.businessName}
      secondaryText={(record) => (
        <Typography>{`${record.firstName} ${record.lastName}`}</Typography>
      )}
      tertiaryText={(record) => record.submitDate}
      // rightIcon={() => <ChevronRightIcon fontSize="large" color="secondary" style={{marginLeft: 40, marginTop: 10}} />}
      linkType="edit"
    />
  ) : isSmall ? (
    <Datagrid rowClick="edit" {...props}>
      <TextField source="businessName" label="Yard Name" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <DateField source="submitDate" label="Submit Date" showTime />
    </Datagrid>
  ) : (
    <Datagrid rowClick="edit" {...props}>
      <TextField source="businessName" label="Yard Name" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="cognitoId" />
      <DateField source="submitDate" label="Submit Date" showTime />
    </Datagrid>
  );
};

export default SetupList;
